import { useState, useEffect, useRef, Children, cloneElement } from 'react';
import { cn } from '../../lib/utils';

export const Reveal = ({
    children,
    className,
    delay = 0,
    duration = 1000,
    direction = 'up', // 'up', 'down', 'left', 'right', 'none'
    threshold = 0.1,
    once = true,
}) => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    if (once) observer.unobserve(entry.target);
                } else if (!once) {
                    setIsVisible(false);
                }
            },
            { threshold }
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            if (ref.current) observer.unobserve(ref.current);
        };
    }, [threshold, once]);

    const getTransform = () => {
        switch (direction) {
            case 'up': return 'translate-y-20';
            case 'down': return '-translate-y-20';
            case 'left': return '-translate-x-20';
            case 'right': return 'translate-x-20';
            default: return '';
        }
    };

    return (
        <div
            ref={ref}
            className={cn(
                "transition-all ease-out transform-gpu",
                isVisible
                    ? "opacity-100 translate-x-0 translate-y-0 filter-none"
                    : `opacity-0 ${getTransform()} blur-sm`,
                className
            )}
            style={{
                transitionDuration: `${duration}ms`,
                transitionDelay: `${delay}ms`
            }}
        >
            {children}
        </div>
    );
};
